let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jle6Z")).then(() => parcelRequire('iNP4c'));